var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('div',{staticClass:"margintop-32"},[_c('tl-tabs',{attrs:{"tabs":_vm.tabs}},[_c('tl-tab',[_c('hold-salary')],1),_c('tl-tab',[_c('stop-salary')],1),_c('tl-tab',[_c('active-salary')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }